module.exports = __webpack_public_path__ + "static/img/background.07f811cf.svg";